<div class="custom-toast" [ngClass]="'custom-toast--' + data.type">
  <div class="custom-toast__icon-wrapper">
    @switch (data.type) {
      @case ('error') {
        <i class="bi bi-exclamation-octagon-fill text-danger fs-4"></i>
      }
      @case ('success') {
        <i class="bi bi-check-circle-fill text-success fs-4"></i>
      }
      @case ('warn') {
        <i class="bi bi-exclamation-triangle-fill text-warning fs-4"></i>
      }
      @case ('info') {
        <i class="bi bi-info-circle-fill text-primary fs-4"></i>
      }
    }
  </div>

  <div class="custom-toast__body">
    <div class="custom-toast__title">
      {{ data.title || getDefaultTitle(data.type) }}
    </div>
    <div class="custom-toast__message">
      {{ data.message }}
    </div>
  </div>

  <button
    type="button"
    class="custom-toast__close"
    (click)="dismiss()"
    aria-label="Close notification"
  >
    <i class="bi bi-x-lg"></i>
  </button>
</div>
